<style>
.third {
  border-color: #0057f9;
  color: #fff;
  box-shadow: 0 0 40px 40px #0042d1 inset, 0 0 0 0 #0137e7;
  -webkit-transition: all 150ms ease-in-out;
  transition: all 150ms ease-in-out;
}

.third:hover {
  box-shadow: 0 0 10px 0 #0089f9 inset, 0 0 10px 4px #0081f9;
  color: rgb(0, 0, 0);
}
</style>
<template>
  <div>
    <div class="content-box" style="padding: 0rem 2rem">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-box" style="height: 100px">
            <h5 class="form-header">
              Pedido &nbsp;
              <span v-if="current.numero != null"># {{ current.numero }}</span>
              &nbsp;
              <div class="badge" :class="{
                'badge-success': current.estado == 'A',
                'badge-warning': current.estado == 'B',
                'badge-danger': current.estado == '9',
              }">
                <i class="os-icon os-icon-ui-09"></i>
                <span v-if="current.estado_str">{{ current.estado_str }}</span>
                <span v-if="!current.estado_str">En Proceso</span>
              </div>

              <div class="st-meta float-right">
                <div class="element-actions">
                  <div class="form-header">
                    <button @click="refreshCurrent()" class="btn btn-info">
                      <i class="fas fa-sync"></i> Actualizar Info.
                    </button>
                    &nbsp;
                    <button type="button" data-toggle="modal" data-target="#modalLog" class="btn btn-info">
                      <i class="fas fa-history"></i>
                      Log de transacciónes
                    </button>
                    <div class="btn-group">
                      &nbsp; &nbsp;
                      <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown" type="button">
                        <i class="fas fa-print"></i>
                        Impresiones
                      </button>

                      <div class="dropdown-menu dropdown-menu-right">
                        <button class="dropdown-item" @click="imprimirReportePicking()">
                          <i class="fas fa-file-pdf"></i> Imprimir Picking
                        </button>
                        <button class="dropdown-item" @click="imprimir" :disabled="current.estado == 'A'">
                          <i class="fas fa-file-pdf"></i>
                          Imprimir Cotización
                        </button>
                        <button class="dropdown-item" @click="imprimirXls()">
                          <i class="fa fa-file-excel"></i>

                          Imprimir Cotización.xls
                        </button>
                        <button class="dropdown-item" @click="imprimirDevoluciones()">
                          <i class="fas fa-file-pdf"></i> Imprimir Devolución
                        </button>
                      </div>
                    </div>
                    &nbsp;
                    <div class="btn-group">
                      <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown" type="button">
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                          :disabled="!(current.estado == 'B')" href="#">
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button class="dropdown-item" @click="generarCotizacion(current)"
                          :disabled="!(current.estado == 'A')" href="#">
                          <i class="fas fa-clipboard-check"></i>
                          Generar Cotización
                        </button>
                        <button class="dropdown-item" @click="cerrar" :disabled="!(current.estado == 'A')" href="#">
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <button class="dropdown-item" @click="enviar_picking" :disabled="!(current.estado == 'B')"
                          href="#">
                          <i class="fas fa-people-carry"></i>
                          Enviar a Picking
                        </button>
                        <button class="dropdown-item" @click="asignarRutaModal" :disabled="!(current.estado == 'A')"
                          href="#">
                          <i class="fas fa-shipping-fast"></i>
                          Asignar a ruta
                        </button>
                        <div class="dropdown-divider"></div>
                        <button class="dropdown-item" @click="anular" :disabled="!(current.estado != '9')" href="#">
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box" style="padding: 0rem 2rem">
      <div class="row">
        <div class="col-lg-9">
          <div class="element-box" style="padding: 1rem 2rem">
            <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
              current.errors.detail
            }}</small>
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for>Tienda</label>
                  <div class="input-group">
                    <input disabled v-model="current.tienda.nombre" class="form-control" type="text" />
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for>Caja</label>
                  <div class="input-group">
                    <input disabled v-model="current.caja.caja" class="form-control" placeholder="Caja" type="text" />
                  </div>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label>Vendedor</label>
                  <input :disabled="true" class="form-control" v-model="current.vendedor" type="text" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for>Fecha</label>
                  <div class="input-group">
                    <input disabled v-model="current.fecha" class="form-control" placeholder="Fecha" type="text" />
                  </div>
                </div>
              </div>
              <div class="col-sm-3" v-if="current.cliente">
                <div class="form-group">
                  <label>Nit del Cliente</label>
                  <div class="input-group">
                    <input id="nit" disabled ref="nit" v-if="current.cliente" v-model="current.cliente.nit"
                      class="form-control" placeholder="Nit" type="text" />
                  </div>
                </div>
              </div>
              <div class="col-sm-9" v-if="current.cliente">
                <div class="form-group">
                  <label for>Nombre del Cliente</label>
                  <div class="input-group">
                    <input id="nombre" disabled ref="nombre" v-model="current.cliente.nombre" class="form-control"
                      placeholder="Nombre" type="text" />
                  </div>
                </div>
              </div>
              <div class="col-sm-3" v-if="current.super_cliente">
                <div class="form-group">
                  <label>Codigo super cliente</label>
                  <div class="input-group">
                    <input id="nit" disabled ref="nit" v-if="current.cliente" v-model="current.super_cliente.codigo"
                      class="form-control" placeholder="Nit" type="text" />
                  </div>
                </div>
              </div>
              <div class="col-sm-6" v-if="current.super_cliente">
                <div class="form-group">
                  <label for>Nombre super cliente</label>
                  <div class="input-group">
                    <input id="nombre" disabled ref="nombre" v-model="current.super_cliente.nombre" class="form-control"
                      placeholder="Nombre" type="text" />
                  </div>
                </div>
              </div>
              <div class="col-sm-3" v-if="current.ruta_reparto">
                <div class="form-group">
                  <label for>Ruta Reparto</label>
                  <div class="input-group">
                    <input id="nombre" disabled ref="nombre" v-model="current.ruta_reparto.nombre" class="form-control"
                      placeholder="Nombre" type="text" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-buttons-w">
              <router-link class="btn btn-outline-info" :to="{ name: 'pos-pedidos' }">
                <i class="fa fa-arrow-left"></i>
                Ir a listado
              </router-link>
              <button v-if="current.estado == 'A'" class="btn btn-md btn-dark" data-target="#modificarCliente"
                data-toggle="modal" href="#">
                <i class="os-icon os-icon-edit-1"></i>
                <span>Cambiar Cliente</span>
              </button>
              <button v-if="current.estado == 'A' && current.tipo_pago == 'CREDITO'" class="btn btn-md third"
                @click="facturarPedido(current)" onmouseover="this.style.color='black'"
                onmouseout="this.style.color='white'" data-toggle="tooltip" data-placement="top">
                <i class="fas fa-cash-register"></i>
                <span> Facturar a Crédito</span>
              </button>
              <button v-if="current.estado == 'A' && current.tipo_pago == 'CONTADO'" class="btn btn-md third"
                @click="showModalFormaPago" onmouseover="this.style.color='black'" onmouseout="this.style.color='white'"
                data-toggle="tooltip" data-placement="top">
                <i class="fas fa-dollar-sign"></i>
                <span> Agregar Forma de Pago</span>
              </button>
              <AgregarFormaPagoModalComponent :formas_pagos="formas_pagos" :current="current"
                @refreshCurrent="refreshCurrent" />
            </div>
            <CambiarModalComponent :current="current" :detalle="detalle_linea" @refresh="refreshCurrent" />
          </div>
        </div>
        <div class="col-3">
          <div class="element-box">
            <div style="border-right: blue 5px solid" class="text-center">
              <p style="font-weight: bold">Total</p>
              <h4 v-if="current.total" class="text-success" style="font-weight: bold">
                Q {{ current.total.toFixed(2) }}
              </h4>
              <hr />
              <p style="font-weight: bold">Pendiente de Pagar</p>
              <h4 v-if="current.pendiente_pagar" class="text-success" style="font-weight: bold">
                Q {{ current.pendiente_pagar.toFixed(2) }}
              </h4>
              <hr />
              <p style="font-weight: bold">Total de Pagado</p>
              <h4 v-if="current.total_pagado" class="text-success" style="font-weight: bold">
                Q {{ current.total_pagado.toFixed(2) }}
              </h4>
            </div>
            <hr />
            <br />
            <div style="border-left: blue 5px solid" class="text-center">
              <h6 style="font-weight: bold">Forma de Pago</h6>
              <h5 class="text-success" style="font-weight: bold">
                {{ current.tipo_pago }}
              </h5>
              <br />

              <button v-if="current.estado == 'A'" data-target="#modificarFormaPago" data-toggle="modal" href="#"
                class="btn btn-sm btn-dark">
                <i class="fas fa-money-bill-wave"></i>
                <span> Cambiar Tipo Pago</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-box" style="padding: 0rem 2rem">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div class>
                <button type="button" class="btn btn-sm btn-success btn-block" @click="showModalAddDetail"
                  v-if="current.estado == 'A'">
                  <i class="fa fa-plus"></i>
                  Agregar Producto
                </button>
              </div>
              <br />
              <h6>Detalle de productos</h6>
              <div class="table-responsive" v-if="current.id != null">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Sku</th>
                      <th>Descripción</th>
                      <th class="text-center">Cantidad</th>
                      <th class="text-center">Unidad Medida</th>
                      <th class="text-right">Precio</th>
                      <th class="text-right">Total: Q {{ current.total }}</th>
                      <th class="text-center" v-if="current.estado == 'A'"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.cxcpedidod_set" v-bind:key="detalle.id">
                      <td>{{ detalle.producto.sku }}</td>
                      <td>{{ detalle.descripcion }}</td>
                      <td class="text-center">{{ detalle.cantidad_um }}</td>
                      <td class="text-center">
                        {{ detalle.unidad_medida.nombre }}
                      </td>
                      <td class="text-right">Q {{ detalle.precio }}</td>
                      <td class="text-right">Q {{ detalle.total }}</td>
                      <td class="text-center" v-if="current.estado == 'A'">
                        <div class="btn-group dropleft">
                          <a class="btn btn-sm btn-info dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Opciones
                          </a>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <a class="dropdown-item" style="background-color: #ff7979" href="#"
                              @click="deleteDetalle(detalle)">
                              Eliminar Linea <i class="fa fa-trash"></i></a>
                            <a class="dropdown-item" @click="showModalDescuentoPrecio(detalle)"
                              style="background-color: #79c4ff">Descuento Precio
                              <i class="fas fa-coins"></i>
                            </a>
                            <!-- Opcion inactiva: Descuento Subtotal
                            <a @click="showModalDescuentoSubTotal(detalle)" class="dropdown-item"
                              style="background-color: #3689ff">Descuento Subtotal <i class="fas fa-coins"></i></a>
                            -->
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqCompra" role="dialog" tabindex="-1"
      data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button @click="cerrarModalDetalle" class="close" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="agregaDetalle">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label v-bind:class="{
                          'text-danger':
                            currentDetalle.errors &&
                            currentDetalle.errors.length > 0,
                        }"></label>
                        <ProductoSelectComponent :current="currentDetalle" @input="refreshUnidadMedida" />
                        <small v-if="currentDetalle.errors" class="form-text text-danger"></small>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label v-bind:class="{
                          'text-danger':
                            currentDetalle.errors.unidad_medida &&
                            currentDetalle.errors.unidad_medida.length > 0,
                        }">Unidad de Medida</label>
                        <select class="form-control" v-model="currentDetalle.precio_actual">
                          <option v-for="(precio, key) in currentDetalle.producto
                          .lista_precios" :value="precio" :key="key">
                            {{ precio.unidad_medida.nombre }}
                          </option>
                        </select>
                        <small v-if="
                          currentDetalle.errors &&
                          currentDetalle.errors.unidad_medida
                        " class="form-text text-danger">{{ currentDetalle.errors.unidad_medida[0] }}</small>
                      </div>
                    </div>
                    <br />
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label v-bind:class="{
                          'text-danger':
                            currentDetalle.errors.cantidad &&
                            currentDetalle.errors.cantidad.length > 0,
                        }">Cantidad en Unidad de Medida</label>
                        <input v-model="currentDetalle.cantidad" class="form-control" placeholder="Cantidad" type="text"
                          style="text-align: center; font-size: 200%" v-bind:class="{
                            'is-invalid':
                              currentDetalle.errors.cantidad &&
                              currentDetalle.errors.cantidad.length > 0,
                          }" />
                        <small v-if="
                          currentDetalle.errors &&
                          currentDetalle.errors.cantidad
                        " class="form-text text-danger">{{ currentDetalle.errors.cantidad[0] }}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" v-if="currentDetalle.producto.sku != null">
                  <ProductoTiendaMiniTableComponent :current="currentDetalle.producto"
                    :filtrartienda="current.tienda.codigo" />
                  <h6 class="element-header">Precios</h6>
                  <div class="invoice-table">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Unidad de Medida</th>
                          <th class="text-right">Cantidad X Precio</th>
                          <th class="text-right">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in currentDetalle.producto
                        .lista_precios" v-bind:key="detalle.id">
                          <td>
                            {{ detalle.unidad_medida.nombre }}
                          </td>
                          <td class="text-right" v-if="
                            currentDetalle.precio_actual != null &&
                            currentDetalle.precio_actual.unidad_medida.id ==
                            detalle.unidad_medida.id
                          ">
                            {{ currentDetalle.cantidad }} X Q
                            {{ currentDetalle.precio_actual.precio }}
                          </td>
                          <td class="text-right" v-if="
                            currentDetalle.precio_actual != null &&
                            currentDetalle.precio_actual.unidad_medida.id !=
                            detalle.unidad_medida.id
                          ">
                            Q {{ detalle.precio }}
                          </td>
                          <td class="text-right" style="font-weight: bold" v-if="
                            currentDetalle.precio_actual != null &&
                            currentDetalle.precio_actual.unidad_medida.id ==
                            detalle.unidad_medida.id
                          ">
                            Q
                            {{
                            (
  currentDetalle.precio_actual.precio *
  currentDetalle.cantidad
).toFixed(2)
                            }}
                          </td>
                          <td class="text-right" v-if="
                            currentDetalle.precio_actual != null &&
                            currentDetalle.precio_actual.unidad_medida.id !=
                            detalle.unidad_medida.id
                          ">
                            Q 0.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" :disabled="verificarUnidades()" type="submit">
                Agregar
              </button>
              <button class="btn btn-secondary" @click="cerrarModalDetalle" type="button">
                Cerrar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Asignación de Ruta
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <SuperClientesSelectComponent :current="current" />
            </div>
            <div class="col-12">
              <div class="form-group">
                <label v-bind:class="{
                  'text-danger':
                    current.errors && current.errors.ruta_reparto,
                }">Ruta Reparto</label>
                <select class="form-control" required v-model="current.ruta_reparto">
                  <option v-for="(det, key) in rutas_reparto" :value="det.id" :key="key">
                    {{ det.id }} -
                    {{ det.nombre }}
                  </option>
                </select>
                <small v-if="current.errors && current.errors.ruta_reparto" class="form-text text-danger">{{
                  current.errors.ruta_reparto[0]
                }}</small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cerrar
            </button>
            <button @click="asignar_ruta()" type="button" class="btn btn-primary">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="current.id">
      <LogModalComponent modulo="cxc" transac="pedidos" :id="current.id" />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PedidosServices from "@/services/pos/PedidosServices";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import CambiarModalComponent from "@/components/pos/CambiarModalComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import SuperClientesSelectComponent from "@/components/commons/SuperClientesSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import AgregarFormaPagoModalComponent from "@/components/pos/AgregarFormaPagoModalComponent";
import ProductoTiendaMiniTableComponent from "@/components/cat/productos/ProductoTiendaMiniTableComponent";
import LogModalComponent from "@/components/commons/LogModalComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    ProductoSelectComponent,
    CambiarModalComponent,
    AgregarFormaPagoModalComponent,
    ProductoTiendaMiniTableComponent,
    SuperClientesSelectComponent,
    LogModalComponent,
  },
  data() {
    return {
      detalle_linea: {},
      rutas_reparto: [],
      error: [],
      formas_pagos: [],
      current: {
        id: null,
        tipo: "V",
        total: 0,
        caja: {
          caja: "",
        },
        cliente: {
          nit: "",
          nombre: "",
        },
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      proveedores: [],

      productos: [],
      options: [],

      currentDetalle: {
        cantidad: "",
        precio_actual: null,
        producto: {
          sku: null,
          lista_precios: [],
        },
        unidad_medida: null,
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    Vue.config.keyCodes.f2 = 113;
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
      ProductosService.fetch({
        page: 1,
        activod: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
    }
  },
  methods: {
    imprimirXls() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=cxc/pedidos/Pedido_excel.jrxml&id=${self.id}`
      );
    },
    refreshDataRutasReparto() {
      DynamicService.fetch("cat", "ruta-reparto").then((response) => {
        this.rutas_reparto = response.data.results;
      });
    },
    asignarRutaModal() {
      this.refreshDataRutasReparto();
      $("#exampleModal").modal("show");
    },
    asignar_ruta() {
      let self = this;
      Notifications.alert.confirm(
        "Asignar pedido a Picking",
        "¿Esta Seguro?",
        "",
        function () {
          DynamicService.postAction(
            "cxc",
            "pedidos",
            self.current.id,
            "asignar_pedido_a_ruta",
            {
              ruta_reparto: self.current.ruta_reparto,
              super_cliente: self.current.super_cliente.codigo,
            }
          )
            .then((reponse) => {
              Notifications.alert.success(
                "El Pedido se ha asignado a una ruta",
                "Realizado Correctamente"
              );
              $("#exampleModal").modal("hide");
              self.refreshCurrent();
            })
            .catch((error) => {
              var errors;
              console.log(error.response.data);
              if (error.response.data.total_pagado) {
                errors = error.response.data.total_pagado;
              }
              Notifications.alert.error("Asignar a Ruta", errors);
            });
        }
      );
    },
    imprimirReportePicking() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/OrdenDespacho.jrxml&Id=${self.id}`
      );
    },
    enviar_picking() {
      let self = this;
      Notifications.alert.confirm(
        "Enviar a Picking",
        "¿Esta Seguro, el pedido no podrá ser abierto despues de realizar esta acción?",
        "",
        function () {
          DynamicService.postAction(
            "cxc",
            "pedidos",
            self.current.id,
            "enviar_a_picking"
          )
            .then((reponse) => {
              Notifications.alert.success(
                "El Pedido se ha colocado en la cola para Despachos",
                "Realizado Correctamente"
              );

              self.refreshCurrent();
              self.imprimirReportePicking();
            })
            .catch((error) => {
              var errors;
              console.log(error.response.data);
              if (error.response.data.total_pagado) {
                errors = error.response.data.total_pagado;
              }
              Notifications.alert.error("Enviar a Picking", errors);
            });
        }
      );
    },
    showModalDescuentoPrecio(detalle) {
      this.detalle_linea.id = detalle.id;
      $("#modificarPrecioLinea").modal();
    },
    showModalDescuentoSubTotal(detalle) {
      this.detalle_linea.id = detalle.id;
      $("#modificarPrecioSubtotal").modal();
    },
    facturarPedido(current) {
      let self = this;
      Notifications.alert.confirm(
        "Facturar Pedido",
        "¿Esta Seguro?",
        "",
        function () {
          DynamicService.postAction("cxc", "pedidos", current.id, "facturar")
            .then((reponse) => {
              Notifications.alert.success(
                "Facturar Pedido",
                "Realizado Correctamente"
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              var errors;
              if (error.response.data.total_pagado) {
                errors = error.response.data.total_pagado;
              }
              Notifications.alert.error("Facturar Pedido", errors);
            });
        }
      );
    },
    cerrarModalDetalle() {
      if (this.currentDetalle.producto) {
        this.currentDetalle.producto.lista_precios = "";
        this.currentDetalle.producto = "";
        this.currentDetalle.cantidad = "";
      }
      $("#modalAddDetailReqCompra").modal("hide");
    },
    showModalFormaPago() {
      let self = this;
      DynamicService.fetch("cat", "forma-pago").then((response) => {
        self.formas_pagos = response.data.results;
        $("#aggFormaPago").modal();
      });
    },
    generarCotizacion(current) {
      let self = this;
      DynamicService.postAction(
        "cxc",
        "pedidos",
        current.id,
        "generar_cotizacion"
      ).then((response) => {
        Notifications.alert.success(
          "Generar Cotización",
          "¡Realizado con éxito!"
        );
        self.$router.push({
          name: "pos-cotizaciones-editar",
          params: { id: self.current.id },
        });
      });
    },
    refreshUnidadMedida() {
      let self = this;
      if (self.currentDetalle.producto == null) {
        self.currentDetalle.producto = {
          lista_precios: [],
        };
        return;
      }
      if (self.currentDetalle.producto.sku == null) {
        self.currentDetalle.producto["lista_precios"] = [];
        return;
      }
      DynamicService.getByIdParams(
        "cat",
        "productos",
        self.currentDetalle.producto.sku,
        {
          tienda: self.current.tienda.codigo,
        }
      ).then((response) => {
        console.log(response.data);
        self.currentDetalle.producto = response.data;
        if (self.currentDetalle.producto.lista_precios.length > 0) {
          self.currentDetalle.precio_actual =
            self.currentDetalle.producto.lista_precios[0];
        } else {
          self.currentDetalle.precio_actual = null;
        }
      });
    },

    refreshExtrasProductos() {
      let self = this;
    },

    refreshCurrent() {
      let self = this;
      PedidosServices.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.vendedor = response.data.vendedor.name;
        self.current.fecha = self.customFormatterInverted(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = "";
      });
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("YYYY-MM-DD");
    },

    showModalAddDetail() {
      $("#modalAddDetailReqCompra").modal();
    },

    verificarUnidades() {
      let self = this;
      let _tienda_codigo = self.current.tienda.codigo;
      let producto_tienda_actual = null;
      for (let pt in self.currentDetalle.producto.productotienda_set) {
        let _pt = self.currentDetalle.producto.productotienda_set[pt];
        if (_pt.tienda == _tienda_codigo) {
          producto_tienda_actual = _pt;
        }
      }
      if (producto_tienda_actual == null) {
        return false;
      }
      return !(
        producto_tienda_actual.existencia_disponible >=
        self.currentDetalle.cantidad
      );
    },
    agregaDetalle(e) {
      e.preventDefault();
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      var _params = {
        producto: det.producto.sku,
        cantidad: det.cantidad,
      };
      if (det.precio_actual) {
        _params["unidad_medida"] = det.precio_actual.unidad_medida.id;
      }

      PedidosServices.agregar_detalle_um(self.current.id, _params)
        .then((response) => {
          $("#modalAddDetailReqCompra").modal("hide");
          self.refreshCurrent();
          if (self.currentDetalle.producto) {
            self.currentDetalle.producto.lista_precios = "";
            self.currentDetalle.producto = "";
            self.currentDetalle.cantidad = "";
          }
        })
        .catch((error) => {
          var errors;
          if (error.response.data.detail) {
            errors = error.response.data.detail;
          } else {
            let _errors = error.response.data;
            errors = "";
            for (var propertyName in _errors) {
              errors += " " + `${propertyName} = ${_errors[propertyName]}`;
            }
          }
          Notifications.alert.error("Agregar Detalle", errors);
        });
    },

    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          PedidosServices.eliminar_detalle(detalle.pedido_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          PedidosServices.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          PedidosServices.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          PedidosServices.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    imprimir() {
      let id;
      id = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let user = localStorage.getItem("id_usuario");
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/Pedido.jrxml&usuario=${user}&id=${id}`
      );
    },
    imprimirDevoluciones() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/Devolucion_ProductoND.jrxml&Id=${self.id}`
      );
    },
  },
};
</script>
